
















import { Prop, Component, Vue } from 'vue-property-decorator'
import { __ } from 'bits/intl'
import OzIcon from 'library/v4/components/OzIcon.vue'
import OzContainedButton, {
  OzContainedButtonColorScheme,
  OzContainedButtonSizePreset,
} from 'library/v4/components/OzContainedButton.vue'

@Component({ components: { OzIcon, OzContainedButton } })
export default class OzCloseButton extends Vue {
  ColorScheme = OzContainedButtonColorScheme
  SizePreset = OzContainedButtonSizePreset

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Color scheme
   */
  @Prop({ default: undefined }) colorScheme?: OzContainedButtonColorScheme

  get label(): string {
    return __('Close')
  }

  handleClick(event): void {
    /**
     * Click event.
     * @property {MouseEvent} event click event
     */
    this.$emit('click', event)
  }
}
